import { render, staticRenderFns } from "./BlogsCreate.vue?vue&type=template&id=a19f6178"
import script from "./BlogsCreate.vue?vue&type=script&lang=ts"
export * from "./BlogsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports